import {
    CORE_GET_ALL_USER_GROUP_REQUEST,
    CORE_GET_ALL_USER_GROUP_SUCCESS,
    CORE_GET_ALL_USER_GROUP_FAILURE,

    CORE_GET_USER_GROUP_BY_ID_REQUEST,
    CORE_GET_USER_GROUP_BY_ID_SUCCESS,
    CORE_GET_USER_GROUP_BY_ID_FAILURE,

    CORE_CREATE_USER_GROUP_REQUEST,
    CORE_CREATE_USER_GROUP_SUCCESS,
    CORE_CREATE_USER_GROUP_FAILURE,

    CORE_UPDATE_USER_GROUP_REQUEST,
    CORE_UPDATE_USER_GROUP_SUCCESS,
    CORE_UPDATE_USER_GROUP_FAILURE,

} from '../../settingsType'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    usergroups: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_USER_GROUP_REQUEST:
                return state
            case CORE_GET_ALL_USER_GROUP_SUCCESS:
                if (action.payload) {
                    console.log(action.payload)
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_USER_GROUP_FAILURE:
                return []
            default:
                return state
        }
    },
    usergroup: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_USER_GROUP_BY_ID_REQUEST:
                return state
            case CORE_GET_USER_GROUP_BY_ID_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_USER_GROUP_BY_ID_FAILURE:
                return {}
            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/settings/userGroup.js